/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询首页频道
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.ChannelDetailDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/channels`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
